import React from 'react';
import ThemeToggleButton from './ThemeToggleButton';

const Navbar = ({ step, toggleModal, toggleTheme, onReset, onContinue, isContinueEnabled }) => {
  const continueButtonText = step === 1 ? "¡Vamos a las ubicaciones!" : "Continuar";

  const handleDisabledClick = () => {
    if (!isContinueEnabled) {
      alert('¡Por favor, completa este paso antes de continuar! 😊');
    }
  };

  return (
    <nav className="fixed-navbar flex justify-between items-center p-4 bg-white dark:bg-gray-800 shadow-lg">
      {(step === 1 || step === 2) && (
        <button
          onClick={isContinueEnabled ? onContinue : handleDisabledClick}
          className={`flex-1 mx-2 p-4 bg-blue-600 text-white rounded-lg shadow-lg text-center ${isContinueEnabled ? '' : 'opacity-50 cursor-not-allowed'}`}
          aria-label={continueButtonText}
          disabled={!isContinueEnabled}
        >
          {continueButtonText}
        </button>
      )}

      {step === 3 && (
        <>
          <button
            onClick={toggleModal}
            className="flex-1 mx-2 p-4 bg-blue-600 text-white rounded-lg shadow-lg text-center"
            aria-label="Ver historial de tareas"
          >
            Historial 📜
          </button>
          <button
            onClick={onReset}
            className="flex-1 mx-2 p-4 bg-red-600 text-white rounded-lg shadow-lg text-center"
            aria-label="Volver a empezar"
          >
            Reiniciar
          </button>
        </>
      )}

      <div className="flex items-center justify-center mx-2">
        <ThemeToggleButton toggleTheme={toggleTheme} />
      </div>
    </nav>
  );
};

export default Navbar;
